var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAiIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 20C0 8.9543 8.95431 0 20 0H50C61.0457 0 70 8.95431 70 20V50C70 61.0457 61.0457 70 50 70H20C8.9543 70 0 61.0457 0 50V20Z",
    fill: "#F1935C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9722 49.3168V22.4822C18.9722 20.5435 20.5437 18.972 22.4824 18.972H47.0538C48.9925 18.972 50.564 20.5435 50.564 22.4822V40.0332C50.564 41.9719 48.9925 43.5434 47.0538 43.5434H27.6797C26.6133 43.5434 25.6048 44.0281 24.9387 44.8608L20.8475 49.9746C20.2257 50.7519 18.9722 50.3123 18.9722 49.3168Z",
    stroke: "white",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiIcon);
export default __webpack_public_path__ + "static/media/AiIcon.ca61d3f631df7ba0abe9de8e2886fec7.svg";
export { ForwardRef as ReactComponent };